import { render, staticRenderFns } from "./CompanyCode.vue?vue&type=template&id=4d7a68f2"
import script from "./CompanyCode.vue?vue&type=script&lang=js"
export * from "./CompanyCode.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports